import { List, Map } from 'immutable'
import {
  CREATE_PAYMENT,
  DELETE_PAYMENT,
  UPDATE_PAYMENT,
  VOID_PAYMENT,
  SET_UNSYNCED_PAYMENT_CARDREADER,
  SET_UNSYNCED_PAYMENT_SERVER,
  UNSET_UNSYNCED_PAYMENT_SERVER,
  UNSET_UNSYNCED_PAYMENT_CARDREADER,
} from './ActionTypes'

/**
 * POS Meta
 * @typedef {Object} PosMeta
 * @property {String} displayType
 * @property {String} refId
 */

/**
 * Payment
 * @typedef {Object} Payment
 * @property {String} uuid
 * @property {Number} amount // in cents
 * @property {String} type // PAYMENT_TYPES_INTERNAL
 * @property {Number} tip // in cents
 * @property {Object} attributes // card reader attributes
 * @property {String} status
 * @property {posMeta} PosMeta
 */

/**
 * Payment State
 * @returns {Map}
 * @property {Map} unsynced
 * @property {Map} synced
 * @property {Map} payments // Map(orderUuid, Map(paymentUuid, Payment))
 * @property {Map} orderUuid // Map(orderUuid, Map(paymentUuid, Payment))
 */
const initialState = () => {
  return Map({
    unsyncedServerPayments: Map(), // Map(orderUuid, List(...paymentUuids))
    unsyncedCardReaderPayments: Map(), // Map(orderUuid, List(...paymentUuids))
    payments: Map(), // Map(orderUuid, Map(paymentUuid, Payment))
  })
}

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    // payment actions
    case CREATE_PAYMENT:
      return state.setIn(['payments', action.payload.orderUuid, action.payload.payment.uuid], action.payload.payment)
    case UPDATE_PAYMENT:
      return state.updateIn(['payments', action.payload.orderUuid, action.payload.payment.uuid], action.payload.payment)
    case DELETE_PAYMENT:
      return state.deleteIn(['payments', action.payload.orderUuid, action.payload.paymentUuid])
    case VOID_PAYMENT:
      return state
        .setIn(['payments', action.payload.orderUuid, action.payload.paymentUuid, 'amount'], 0)
        .setIn(['payments', action.payload.orderUuid, action.payload.paymentUuid, 'tip'], 0)
        .setIn(['payments', action.payload.orderUuid, action.payload.paymentUuid, 'status'], 'VOIDED')

    // sync actions
    case SET_UNSYNCED_PAYMENT_SERVER:
      return state.updateIn(['unsyncedServerPayments', action.payload.orderUuid], List(), (list) =>
        list.push(action.payload.paymentUuid),
      )
    case SET_UNSYNCED_PAYMENT_CARDREADER:
      return state.updateIn(['unsyncedCardReaderPayments', action.payload.orderUuid], List(), (list) =>
        list.push(action.payload.paymentUuid),
      )
    case UNSET_UNSYNCED_PAYMENT_SERVER:
      return (
        state
          .updateIn(['unsyncedServerPayments', action.payload.orderUuid], List(), (list) => {
            const updatedList = list.filter((paymentUuid) => paymentUuid !== action.payload.paymentUuid)
            return updatedList.size > 0 ? updatedList : undefined
          })
          // when empty cehck if we need to delete order key
          .update((state) => {
            const list = state.getIn(['unsyncedServerPayments', action.payload.orderUuid], List())
            return list.size === 0 ? state.deleteIn(['unsyncedServerPayments', action.payload.orderUuid]) : state
          })
      )
    case UNSET_UNSYNCED_PAYMENT_CARDREADER:
      return (
        state
          .updateIn(['unsyncedCardReaderPayments', action.payload.orderUuid], List(), (list) => {
            const updatedList = list.filter((paymentUuid) => paymentUuid !== action.payload.paymentUuid)
            return updatedList.size > 0 ? updatedList : undefined
          })
          // when empty cehck if we need to delete order key
          .update((state) => {
            const list = state.getIn(['unsyncedCardReaderPayments', action.payload.orderUuid], List())
            return list.size === 0 ? state.deleteIn(['unsyncedCardReaderPayments', action.payload.orderUuid]) : state
          })
      )
    default:
      return state
  }
}

export default reducer
